import { SlidersHorizontalIcon } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import type { ProfileSearchParams } from "common/types";

import useSearchSourceParams from "../../../../hooks/useSearchSourceParams";
import FiltersSelection from "./FiltersSelection";

export default function DesktopFilters({
  accountId,
  searchParams,
  setSearchParams,
}: {
  accountId: string;
  searchParams: ProfileSearchParams;
  setSearchParams: (searchParams: Partial<ProfileSearchParams>) => void;
}) {
  const { hasFilters, resetFilters } = useSearchSourceParams(
    searchParams,
    setSearchParams,
  );

  return (
    <div className="flex w-60 shrink-0 flex-col self-start rounded-3xl border border-black-200">
      <div className="flex items-center gap-x-2 border-b border-black-200 p-3">
        <div className="rounded-xl bg-black-100 p-2">
          <SlidersHorizontalIcon size={16} />
        </div>
        <span className="mr-auto text-sm-bold">Filters</span>
        {hasFilters && (
          <Button variant="link-danger" size="sm" onClick={resetFilters}>
            Clear all
          </Button>
        )}
      </div>

      <div className="py-1.5">
        <FiltersSelection
          accountId={accountId}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>
    </div>
  );
}
